import { getProductsInfo } from '@/fsd/entities/product';
import { IPurchaseProduct } from '@/fsd/entities/product/model/types/IPurchaseProduct';
import { NotificationService } from '@/fsd/shared/lib/notifications';

export const validatePurchaseItem = (
  columns: any,
  products: unknown[],
  type: string,
  conducted: boolean,
  setErrors: (key: string, value: string) => any
) => {
  let isError = false;

  // 1. Check columns
  for (const [key, value] of Object.entries(columns)) {
    // @ts-ignore
    if (value?.required && !value?.value) {
      setErrors(key, 'Это поле обятальное!');
      isError = true;
    } else {
      setErrors(key, '');
    }
  }

  // 2. Check products
  if (!products.length) {
    setErrors('products', 'Выберите продукт!');
    isError = true;
  } else {
    setErrors('products', '');

    for (const [key, value] of Object.entries(products)) {
      // Product top level properties check
      const fieldsToCheck = [];

      if (type === 'purchase' || type === 'shipment') {
        fieldsToCheck.push('count');
      }
      // else fieldsToCheck.push('count_fact');

      for (const key of fieldsToCheck) {
        // @ts-ignore
        const val = value?.[key];
        if (!val || (val && val <= 0)) {
          NotificationService.error({
            message: 'Количество у всех товаров должно быть больше нуля!',
          });
          isError = true;
          break;
        }
      }

      // Product Info check
      const infoFieldsToCheck = [];

      if (type === 'purchase' || type === 'shipment') {
        infoFieldsToCheck.push('in_stock');
        infoFieldsToCheck.push('stock_quantity');
      }

      const info = getProductsInfo({ item: value as IPurchaseProduct });


      for (const key of infoFieldsToCheck) {
        // @ts-ignore
        const val = info?.[key];
        if (val != null && Number(val) < 1 && conducted) {
          NotificationService.error({
            message: `Недостаточно товаров ${
              info?.name
            } на складе! \n На складе: ${
              info?.in_stock || info?.stock_quantity || 0
            }`,
          });
          isError = true;
          break;
        }
      }
    }
  }

  if (isError) return false;

  return true;
};
